let standardCrud = {
    read: {
        params: { action: 'get' }
    },
    create: {
        params: { action: 'create' }
    },
    update: {
        params: { action: 'update' }
    },
    destroy: {
        params: { action: 'delete' }
    }
}

export default {
    instance: {
        defaults: {
            endpoint: 'instanceManager.php',
        },
        ...standardCrud
    }
}
